import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';

import type { IRelatedProducts } from '@Types/RelatedProducts';

export const useApply = (id: number) => {
  const { queryClient } = useRequest();
  const keys = ['related-products', id];

  const { mutateAsync, isPending } = useMutation({
    mutationFn: () => {
      const data = queryClient.getQueryData<IRelatedProducts>(keys);
      return Promise.resolve({ ...data, products: data.changedProducts });
    },
    onSuccess: (data) => {
      queryClient.setQueryData(keys, data);
    },
  });

  return {
    apply: mutateAsync,
    isPending,
  };
};

export default useApply;
